// Familia de seguro según el ramo del producto. La familia decide el formulario de cotización
// y el tipo de condiciones que se envían al backend (docs/dominio/tipos-de-seguro.md).
//
// Tabla temporal: ids del catálogo `Ramos` de simm-dev. Cuando el backend exponga la familia
// en `Ramos`, esta tabla se reemplaza por ese dato.
export const FAMILIA_GMM = 'gmm';
export const FAMILIA_VIDA = 'vida';

const FAMILIA_POR_RAMO = {
  1: FAMILIA_GMM, // GMM
  2: FAMILIA_VIDA, // Vida
};

export function familiaPorRamoId(ramoId) {
  return FAMILIA_POR_RAMO[Number(ramoId)] ?? null;
}

export function esFamiliaSoportada(ramoId) {
  return familiaPorRamoId(ramoId) !== null;
}
